import React, { FC } from 'react';
import styles from './CategoryCard.module.scss';

interface Props {
  imageUrl: string,
  title: string,
  horizontal?: boolean,
}

const CategoryCard: FC<Props> = ({
  imageUrl,
  title,
  horizontal = true,
}) => (
  <div className={styles.card}>
    <div className={`${(horizontal) ? styles.horizontal : styles.vertical} ${styles.cardImage}`}>
      <img
        src={imageUrl}
        alt={title}
        className={styles.image}
      />
    </div>
    <div className={styles.cardFooter}>{title}</div>
  </div>
);

export default CategoryCard;
